import React from "react";
import MwhLogo from "../assets/images/MWHLogo.png";
import {
  MWH_MAIN_PAGE,
  LOGIN_THREELEGGED_URL,
  LOGIN_PAGE_EXTENSION,
} from "../helpers/constants/Constants";

const forgeSignIn = () => {
  fetch(LOGIN_THREELEGGED_URL, { credentials: "include" })
    .then((res) => res.text())
    .then((rootUrl) => {
      window.location.href = rootUrl; //rootUrl;
    })
    .catch(console.log);
};

const rqstAccess = () => {
  //forward to Mark S microsoft form for completion.
  window.open(
    "https://gbr01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fforms.office.com%2FPages%2FResponsePage.aspx%3Fid%3Du0P4N89WbUqYuS6sNuu2BoRUOXRfZWBFlVc1RIGYui9UM1VXNUxBUkRWUlFZOE1RRU5WTk81V1gzMi4u&data=05%7C02%7CRobert.Field%40mwhtreatment.com%7Ca165e73322cd4bba2a8d08debb35855a%7C37f843bb56cf4a6d98b92eac36ebb606%7C0%7C0%7C639154035726658074%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=BboGyYr0vGwlO8%2BD4I7iMdIaX7BdrNmOS3wbfI9hDZI%3D&reserved=0",
    "_blank",
    "noreferrer",
  );
};
// const fgtnPass = () => {
//   //forward to Autodesk function for requesting password change.
//   //https://accounts.autodesk.com/logon?resume=%2Fas%2F4u2VlfBQpJ%2Fresume%2Fas%2Fauthorization.ping&spentity=null#username
// };

const Login = ({ accessDenied = false }) => {
  const bgVideoUrl = `${process.env.PUBLIC_URL}/videos/waterdrop.mp4`;

  return (
    <section className={`loginpage${accessDenied ? " loginpage--no-access" : ""}`}>
      <video className="background-vid" autoPlay loop muted playsInline preload="metadata">
        <source src={bgVideoUrl} type="video/mp4" />
      </video>
      <div className="loginbanner">
        <div className="logincard">
          <div className="cardbody">
            <h1>mView</h1>
            {accessDenied ? (
              <>
                <h2>Access not granted</h2>
                <p>
                  You do not have access to mView.
                </p>
                <p>You have been signed out of mView.</p>
                <p>You can request access below.</p>
              </>
            ) : (
              <p> Please sign in with an MWHT Autodesk account to continue</p>
            )}
            {/* <p> running in....{process.env.NODE_ENV}</p> */}
          </div>
          <div className="signinbtn">
            {accessDenied ? (
              <a href={LOGIN_PAGE_EXTENSION}>Return to sign in</a>
            ) : (
              <button className="signinbtn__primary" onClick={forgeSignIn}>
                SIGN IN
              </button>
            )}
          </div>
          {/* <div className="signinbtn">
            <button onClick={fgtnPass}>FORGOTTEN PASSWORD</button>
          </div> */}
          <div className="signinbtn">
            <button className="signinbtn__secondary" onClick={rqstAccess}>
              REQUEST ACCESS
            </button>
          </div>
          <div className="footer">
            <a href={MWH_MAIN_PAGE}>
              <img src={MwhLogo} alt="" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
